export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";